module.exports = __webpack_public_path__ + "static/media/share-square.12f6a0f6.svg";